<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'PROP.DOCUMENT_FILES' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()" fill="clear">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" fullscreen>
  <ng-container *ngIf="files.length > 0; else noFiles">
    <ion-list>
      <ion-item 
        *ngFor="let file of files" 
        (click)="downloadAttachment($event, file)"
        button
      >
        <ion-label>
          <h3>{{ file.filename }}</h3>
        </ion-label>
        <ion-note slot="end">
          {{ file.filesize | bytes }}
        </ion-note>
      </ion-item>
    </ion-list>
  </ng-container>

  <ng-template #noFiles>
    <div class="ion-text-center ion-padding">
      <p>{{ 'PROP.NO_ATTACHMENTS' | translate }}</p>
    </div>
  </ng-template>
</ion-content>
